import React from 'react'

import Container from '@mui/material/Container'

import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import Form from 'components/account/EmergencyContacts/Form'

const NewEmergencyContact = props => {
  const { mutationLoading, form } = props

  const buttonText = mutationLoading ? 'Creating...' : 'Create'

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[['Account Overview', '/'], ['Emergency Contacts'], ['New']]}
      />
      <Typography gutterBottom variant='h2' align='center'>
        Add an Emergency Contact
      </Typography>
      <Typography pb={4} variant='h3' align='center'>
        (other than parents / guardians)
      </Typography>
      <Container>
        <Typography paragraph fontWeight='fontWeightMedium'>
          NOTE: Emergency contacts will have the ability to pick up the camper
          at any time. Please do not list any person who should not be able to
          leave with the child outside of emergency situations.
        </Typography>
      </Container>
      {!form ? <Loading /> : <Form buttonText={buttonText} {...props} />}
    </Container>
  )
}

export default NewEmergencyContact
